import React, { useState } from 'react';
import TeamItem from '../../../entities/team/ui/TeamItem';
import { exportAdminTeamCsv } from '../../../shared/api/team.services';
import toast from '../../../shared/lib/toast';

const TeamList = ({ data, totalCount }) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExportCsv = async () => {
        if (isExporting) return;
        setIsExporting(true);
        try {
            const result = await exportAdminTeamCsv();
            if (result?.error) {
                toast.error(`Помилка при експорті: ${result.message || 'Невідома помилка'}`);
            }
        } catch (err) {
            console.error('Export failed', err);
            toast.error('Сталася критична помилка при завантаженні файлу');
        } finally {
            setIsExporting(false);
        }
    };

    const shown = data?.items?.length || 0;
    const total = typeof totalCount === 'number' ? totalCount : shown;

    return (
        <div className='admin-list'>
            <div className="admin-list__header">
                <p className="admin-list__header-info">
                    {shown === total ? `${total} учасників` : `Знайдено ${shown} з ${total}`}
                </p>
                <div className="admin-list__header-func">
                    <button
                        onClick={handleExportCsv}
                        disabled={isExporting}
                        className={isExporting ? 'loading' : ''}
                    >
                        {isExporting ? 'Завантаження...' : 'Експорт CSV'}
                    </button>
                </div>
            </div>

            <div className="admin-list__content">
                <ul className="admin-list__content-titles team-grid">
                    <li>Імʼя</li>
                    <li>Посада</li>
                    <li>Видимість</li>
                    <li>Дія</li>
                </ul>
                <ul className="admin-list__content-items">
                    {data?.items?.length > 0 ? (
                        data.items.map((member) => (
                            <TeamItem
                                key={member._id || member.id || member.slug}
                                member={member}
                            />
                        ))
                    ) : (
                        <li className="admin-list__empty">Нічого не знайдено</li>
                    )}
                </ul>
            </div>

            <div className="admin-list__pagination">
            </div>
        </div>
    );
};

export default TeamList;
